module.exports = __webpack_public_path__ + "img/18.fe4b45e3.webp";